import { render, staticRenderFns } from "./UserScientificDegreeForm.vue?vue&type=template&id=20c00f9b&"
import script from "./UserScientificDegreeForm.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegreeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports